module.exports = __webpack_public_path__ + "static/media/requestsMselected.48339763.svg";